import React, {Component} from 'react'
import Rank from "../../../constants/Rank";
import Loader from "../../../components/elements/loader/Loader";
import {NO_PIC_PROFILE} from "../../../constants/profileConstant";

export default class TreeFormContent extends Component {
    render() {
        let loaded = this.props.loaded;
        let interestedListOnly = this.props.interestedListOnly;
        let selectedUser = this.props.selectedUser;
        let empty = this.props.empty;
        let loading = this.props.loading;
        let details = this.props.details;

        let isDelayed;
        let day;
        let delayLabel;
        let delayClass;
        if (details){
            isDelayed = details.remainingDaysToPayQuota < 0;
            day = details.remainingDaysToPayQuota < -1  || details.remainingDaysToPayQuota > 1 ? "días" : "dia";
            delayLabel = isDelayed ? `${-(details.remainingDaysToPayQuota)} ${day} de mora` : `Próximo Pago en ${details.remainingDaysToPayQuota} ${day}`;
            delayLabel = selectedUser.paid ? `` : delayLabel;
            delayClass = isDelayed ? 'badge-warning' : 'badge-success';
            delayClass = selectedUser.inExecution ? 'badge-danger' : delayClass;
            delayClass = selectedUser.reverted ? 'alert-primary' : delayClass;
        }
        return (
            <div className="tree-form-inside-l-2">
                {
                    !this.props.isDesktop ? null : <div className="w-100 tree-form-top"/>
                }
                <div>
                    {
                        !loaded ?
                            <div>
                                <div className="w-100 h-100 block container-centered">
                                    <div className="centered">
                                        <div className="block">
                                            <Loader  square show={true}/>
                                            Cargando...
                                        </div>
                                    </div>
                                </div>
                            </div>

                            : interestedListOnly ?
                            <div className="form-padding">
                                <h3>Interesados</h3>
                                <div className="tree-from-list">
                                    <ul className="list-group">
                                        { selectedUser.interested.map((e) =>
                                            <li className="list-group-item">{e.name} { e.reservePaid ? "Reservado" : "" }</li> )}
                                    </ul>
                                </div>
                            </div>
                            :
                            <div>
                                {
                                    !selectedUser || empty ? null :
                                        <div>
                                            <div className="w-100 container-centered">
                                                <div className="centered rounded-circle">
                                                    <img height={30} width={30}
                                                         className="rounded-circle"
                                                         src={`data:image/png;base64,${selectedUser.image}`}
                                                         onError={(e)=>{e.target.src=NO_PIC_PROFILE}} />
                                                </div>
                                            </div>
                                            <div className="w-100 form-padding">
                                                <div className="top-bottom-9 no-top-margin">
                                                    <div>
                                                        <h3>{selectedUser.name}</h3>
                                                        {
                                                            selectedUser.paid ? <span
                                                                    className="badge badge-pill badge-paid">Pagado</span> :
                                                            selectedUser.onTime ? <span
                                                                    className="badge badge-pill badge-success">Al día</span> :
                                                                selectedUser.inExecution ? <span className="badge badge-pill badge-danger">En Ejecución</span> :
                                                                    selectedUser.reverted ? <span className="badge badge-pill alert-primary">Revertido</span> : <span className="badge badge-pill badge-warning">En Mora</span>
                                                        }

                                                        {
                                                            loading ? null : !details ? null :
                                                                <div className="clearfix">
                                                                    <div className="float-left">
                                                                        <span className={`badge badge-pill ${delayClass}`}>
                                                                            {delayLabel}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="clearfix">
                                                    <div className="float-left">Rango:</div>
                                                    <div className="float-right">{Rank.getByName(selectedUser.rankType)}</div>
                                                </div>

                                                {

                                                    loading ?
                                                        <div>
                                                            <div className="w-100 h-100 block container-centered">
                                                                <div className="centered">
                                                                    <div className="block">
                                                                        <Loader show={true}/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> :
                                                        !details ? null :
                                                            <div>
                                                                <div className="clearfix">
                                                                    <div className="float-left">Patrocinador:</div>
                                                                    <div className="float-right">{details.assignerName}</div>
                                                                </div>
                                                                <div className="clearfix">
                                                                    <div className="float-left">Afiliados de red:</div>
                                                                    <div className="float-right">{details.totalNetworkAffiliates}</div>
                                                                </div>
                                                                <div className="clearfix">
                                                                    <div className="float-left">Afiliados directos:</div>
                                                                    <div className="float-right">{details.totalDirectAffiliates}</div>
                                                                </div>
                                                                <div className="clearfix">
                                                                    <div className="float-left">Telf:</div>
                                                                    <div className="float-right">{details.phone}</div>
                                                                </div>

                                                                <div className="clearfix">
                                                                    <div className="float-left">Correo:</div>
                                                                    <div className="float-right">{details.email}</div>
                                                                </div>
                                                            </div>
                                                }
                                            </div>
                                        </div>
                                }
                            </div>

                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Tree/TreeForm/TreeFormContent.jsx